import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  CurrencyInput,
  ListItemAction,
  useGlobalCopyStore,
  useEvent,
  ANALYTICS_EVENTS,
  useGoalStore,
} from '../../../common'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

export const ExtraPaymentAction = observer(() => {
  const { debts: copy } = useGlobalCopyStore()
  const { monthlyCashFlowProfile, updateMonthlyCashFlowProfile } = useGoalStore()
  const { onEvent } = useEvent()

  const [payment, setPayment] = React.useState<number>(monthlyCashFlowProfile?.extra_payment ?? 0)
  const isInvalid = payment < 0 || payment > 99999999.99

  const handleSave = async () => {
    if (monthlyCashFlowProfile) {
      await updateMonthlyCashFlowProfile({ ...monthlyCashFlowProfile, extra_payment: payment })
      monthlyCashFlowProfile.extra_payment = payment
      onEvent(ANALYTICS_EVENTS.DEBTS_SAVE_PAYDOWN_ACTION, {
        user_guid: monthlyCashFlowProfile?.user_guid,
      })
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setPayment(monthlyCashFlowProfile?.extra_payment ?? 0)
    }, 250)
  }

  return (
    <ListItemAction
      isSaveDisabled={isInvalid}
      label={copy.paydown_drawer_extra_payment}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.paydown_drawer_extra_payment}
      secondaryText={formatCurrency(monthlyCashFlowProfile?.extra_payment, '0,0')}
      zeroStateText={!monthlyCashFlowProfile?.extra_payment ? copy.add_extra_payment : undefined}
    >
      <CurrencyInput
        amount={payment}
        autoFocus={true}
        error={isInvalid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setPayment(!isNaN(Number(v)) ? Number(v) : payment)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
